'use client';
import MagneticBtn from '@/components/ui/buttons/Magnetic';
import TertiaryButton from '@/components/ui/buttons/TertiaryButton';
import { getActiveLocale } from '@/utils/active-locale';
import { useRouter } from 'next/navigation';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Buttons = ({ dictionary }: { dictionary: any }) => {
  const activeLocale = getActiveLocale(); 
  const navigate = useRouter(); 

  const handleVacancies = () => {
    navigate.push(activeLocale + '/voor-talenten/vacatures');
  };
  const handleFindTalent = () => {
    navigate.push(activeLocale + '/voor-opdrachtgevers');
  };

  return (
    <div className='flex gap-x-3 font-fractul pt-4 '>
      <MagneticBtn onClick={handleVacancies} bgColor='bg-yellow-600' hoverBgColor='hover:bg-yellow-500' label={dictionary.home.vacancies} />
      <TertiaryButton onClick={handleFindTalent} textColor='text-white' textHoverColor='hover:text-yellow-100' label={dictionary.home.find_talent} />
    </div>
  );
};
